import type { OmuiDetailTooltipComponent } from '../../../DetailTooltip'

export const OmuiDetailTooltip: OmuiDetailTooltipComponent = {
  defaultProps: {
    placement: 'right',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.neutralLight[0],
      border: `1px solid ${theme.palette.neutralLight[300]}`,
      borderRadius: theme.spacing(2),
      boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.08)',
      minWidth: 260,
      maxWidth: 360,
      color: theme.palette.text.primary,
      textAlign: 'left',
    }),
    header: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      padding: theme.spacing(4),
    }),
    title: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    body: ({ theme }) => ({
      padding: theme.spacing(4),
    }),
    footer: ({ theme }) => ({
      padding: theme.spacing(4),
    }),
  },
}
